import { render, staticRenderFns } from "./CreateChargesView.vue?vue&type=template&id=428d8c62&"
import script from "./CreateChargesView.vue?vue&type=script&lang=js&"
export * from "./CreateChargesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports